export default __webpack_public_path__ + "static/media/visualDesignLogo.be85a4a9.svg";